import { useState } from "react";
import Step1 from "./steps/Step1";
import Step2 from "./steps/Step2";
import Step3 from "./steps/Step3";
import Card from "./../../Components/card/Card";

const CreateRequest = () => {
    const [page, setPage] = useState(0);

    const [formData, setFormData] = useState({
        initialDate: '',
        finalDate: '',
        companyId: '',
        subject: '',
        userIdApprover: '',
        requestDescription: '',
        staffs: [],
        vehicles: [],
    })


    const componentList = [
        <Step1
            formData={formData}
            setFormData={setFormData}
            page={page}
            setPage={setPage}
        />,
        <Step2
            formData={formData}
            setFormData={setFormData}
            page={page}
            setPage={setPage}
        />,
        <Step3
            formData={formData}
            setFormData={setFormData}
            page={page}
            setPage={setPage}
        />
    ]

    return (
        <>
            <Card component={componentList[page]} title={"Crea tu solicitud"} />
        </>
    )

}

export default CreateRequest;